import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

/** Shared by bulk rebalance and the portfolio widget optimizer polling flow. */
const OPTIMIZER_RUN_V2_FIELDS = gql`
  fragment OptimizerRunV2Fields on OptimizerRunV2 {
    id
    type
    state
    preset
    mode
    solverVersion
    portfolioSummary {
      total
      succeeded
      failed
      skipped
    }
    errorMessage
    warnings
    createdAt
    updatedAt
    createdBy {
      referenceId
      firstName
      lastName
    }
  }
`;

export const RUN_PORTFOLIO_OPTIMIZER_V2 = gql`
  mutation runPortfolioOptimizerV2($input: RunPortfolioOptimizerV2Input!) {
    runPortfolioOptimizerV2(input: $input) {
      optimizerRun {
        ...OptimizerRunV2Fields
      }
    }
  }
  ${OPTIMIZER_RUN_V2_FIELDS}
`;

export const FETCH_OPTIMIZER_RUN_V2 = gql`
  query fetchOptimizerRunV2($input: FetchOptimizerRunV2Input!) {
    fetchOptimizerRunV2(input: $input) {
      optimizerRun {
        ...OptimizerRunV2Fields
      }
    }
  }
  ${OPTIMIZER_RUN_V2_FIELDS}
`;

export const FETCH_OPTIMIZER_RUNS_V2 = gql`
  query fetchOptimizerRunsV2($input: FetchOptimizerRunsV2Input!) {
    fetchOptimizerRunsV2(input: $input) {
      optimizerRuns {
        ...OptimizerRunV2Fields
        organization {
          id
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
      }
      totalCount
    }
  }
  ${OPTIMIZER_RUN_V2_FIELDS}
`;
